import { memo } from "react";
import { ReactSVG } from "react-svg";
import VehicleDropdown from "ui/components/Dropdown/VehicleDropdown/VehicleDropdown";
import { DatePicker } from "ui/components/DatePicker";
import { useHandleDateChange, useHandleDropdownChange } from "services/forms/hooks";
import { Errors } from "services/forms/validation/types";
import { MountFormValues } from "../types";

interface MountStep1Props {
  formValues: MountFormValues;
  setFormValues: React.Dispatch<React.SetStateAction<MountFormValues>>;
  errors: Errors;
}

const MountStep1: React.FC<MountStep1Props> = ({ formValues, setFormValues, errors }) => {
  const handleDateChange = useHandleDateChange(setFormValues, formValues);
  const handleDropdownChange = useHandleDropdownChange(setFormValues, formValues);

  return (
    <div className="flex items-center justify-center px-4 min-h-[70vh] xl:min-h-[1000px]">
      <div className="w-full max-w-2xl">
        <h1 className="text-2xl font-bold text-slate-900 text-center mb-1 mb-2">Odaberite vozilo</h1>
        <p className="text-center text-md text-slate-500 mb-8">Na koje vozilo želite montirati odabrani set guma?</p>

        <div className="border bg-white border-slate-200 ">
          {/* Section header */}
          <div className="py-6 px-4">
            <div className="flex items-start gap-3 mb-3">
              <div className="w-10 h-10 rounded-sm bg-slate-100 flex items-center justify-center flex-shrink-0">
                <ReactSVG src="/media/icons/car.svg" className="w-5 h-5 stroke-slate-500" />
              </div>
              <div>
                <div className="text-sm font-semibold text-slate-900">Destinacija vozila</div>
                <div className="text-xs text-slate-500">Odaberite vozilo i datum montaže</div>
              </div>
            </div>
            <div className="">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <VehicleDropdown
                    name="targetVehicleId"
                    label="Vozilo"
                    placeholder="Pretražite vozila..."
                    value={formValues.targetVehicleId}
                    onChange={handleDropdownChange}
                    width="full"
                    error={errors.targetVehicleId}
                    required
                  />
                </div>
                <div>
                  <DatePicker
                    name="transferDate"
                    label="Datum montaže"
                    placeholder="Odaberite datum..."
                    onChange={handleDateChange}
                    error={errors.transferDate}
                    value={formValues.transferDate}
                    width="full"
                    required
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(MountStep1);
